import {Component} from '@angular/core';

@Component({
    selector: 'app-home-layout',
    template: `<router-outlet></router-outlet>`
})

export class homelayoutcomponent{

}
